"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _Label = _interopRequireDefault(require("../Label"));
var _SeatBase = _interopRequireDefault(require("../SeatBase"));
var _utilities = require("../utilities");
var _Seat = require("./Seat.styles");
const _excluded = ["classes", "className", "state", "seatNumber", "orientation", "size", "category", "petsAllowed"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getSizeClassKey(size) {
  return `size${(0, _utilities.capitalizeFirstWord)(size)}`;
}
function getPetSeatClassKey(category) {
  return `petSeat${(0, _utilities.capitalizeFirstWord)(category)}`;
}
function getNumberColor(state) {
  switch (state) {
    case 'hover':
    case 'selected':
      return 'text.positive.translucent';
    case 'available':
      return 'text.secondary.translucent';
    case 'unavailable':
      return 'text.secondary.opaque';
    case 'unavailableMan':
      return 'text.informative.translucent';
    case 'unavailableWoman':
      return 'text.negative.translucent';
    default:
      return 'text.secondary.translucent';
  }
}
/**
 * Display a seat for selection when booking a trip.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-inputs-seat--page)
 */
const Seat = /*#__PURE__*/React.forwardRef(function Seat(props, ref) {
  const {
      classes: classesOverrides,
      className,
      state = 'available',
      seatNumber = '',
      orientation = 'top',
      size = 'lg',
      category = 'standard',
      petsAllowed
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    cx,
    classes
  } = (0, _Seat.useStyles)(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  const shouldShowSeatNumber = !petsAllowed || category !== 'standard' && size !== 'sm';
  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
    className: cx(classes.root, classes[orientation], classes[getSizeClassKey(size)], {
      [classes.available]: state === 'available',
      [classes.selected]: state === 'selected',
      [classes.unavailable]: state.startsWith('unavailable')
    }, className),
    ref: ref
  }, other), seatNumber && shouldShowSeatNumber && /*#__PURE__*/React.createElement(_Label.default, {
    className: cx(classes.seatLabel, classes[category], {
      [classes[getPetSeatClassKey(category)]]: petsAllowed
    }, className),
    color: getNumberColor(state),
    size: size,
    fontWeight: "bold"
  }, seatNumber), /*#__PURE__*/React.createElement(_SeatBase.default, {
    state: state,
    orientation: orientation,
    category: category,
    petsAllowed: petsAllowed,
    size: size
  }));
});
var _default = exports.default = Seat;